import axios from 'axios';

export const dashboardService = {
  getSummary: async () => {
    const response = await axios.get('/api/dashboard/summary/');
    return response.data;
  },
};
